module.exports = __webpack_public_path__ + "static/img/propuestas-1.05a8ac1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/propuestas-1.jpg
// module id = 8ery
// module chunks = 1